import React, { useState } from "react";
import "./LetsConnect.css";

export default function LetsConnect() {
  const [popupVisible, setPopupVisible] = useState(false);
  const [message, setMessage] = useState("");

  const getWordCount = (text) => {
    return text.trim() ? text.trim().split(/\s+/).length : 0;
  };

  const handleMessageChange = (e) => {
    const text = e.target.value;
    if (getWordCount(text) <= 1500) {
      setMessage(text);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    formData.append("access_key", "32863c20-c631-45dc-a23d-4435e962b6bc"); 
    formData.append("send_to", "zzayraat@gmail.com"); 
    formData.append("message_body", message);

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      setPopupVisible(true);
      e.target.reset();
      setMessage("");

      // Set to 5000ms for 5 seconds
      setTimeout(() => {
        setPopupVisible(false);
      }, 5000);
    } else {
      alert("Error: " + data.message);
    }
  };

  return (
    <>
      <div className="lc-section" id="lc-mainSection">
        <div className="lc-header-main" id="lc-pageHeader">Contact us</div>
        <div className="lc-heading-multiline">
          <h2>Your <span className="lc-gold">Brand’s</span> Next Chapter</h2>
          <div className="lc-subtitle">Begins Here</div>
        </div>

        <div className="lc-container-centered">
          <div className="lc-form-box centered-form-box">
            <form id="lc-contactForm" onSubmit={handleSubmit}>
              <div className="lc-form-group">
                <label htmlFor="lc-fname">First name *</label>
                <input type="text" name="name" id="lc-fname" placeholder="Enter your first name" required />
              </div>

              <div className="lc-form-group">
                <label htmlFor="lc-email">Email *</label>
                <input type="email" name="email" id="lc-email" placeholder="Enter your email" required />
              </div>

              <div className="lc-form-group">
                <label htmlFor="lc-phone">Contact Us *</label>
                <input type="tel" name="phone" id="lc-phone" placeholder="Enter your phone number" required />
              </div>

              <div className="lc-form-group">
                <label htmlFor="lc-message">How can we help you? *</label>
                <textarea
                  name="message"
                  id="lc-message"
                  placeholder="Tell us about your project..."
                  required
                  value={message}
                  onChange={handleMessageChange}
                  rows="8"
                />
                <div className="lc-word-count">{getWordCount(message)} / 1500 words</div>
              </div>

              <button type="submit" className="lc-submit-btn">Submit</button>
            </form>
          </div>
        </div>
      </div>

      {/* FIXED VIEWPORT BLUR POPUP */}
      {popupVisible && (
        <div className="lc-blur-overlay">
          <div className="lc-modal-content">
            <div className="lc-modal-icon">🚀</div>
            <h3 className="lc-modal-title">Success!</h3>
            <p className="lc-modal-text">Your journey with Zzayraat begins here</p>
          </div>
        </div>
      )}
    </>
  );
}